/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createRe } from '../../factoriesAny.js';
export var reDependencies = {
  typedDependencies: typedDependencies,
  createRe: createRe
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRe.generated.js
// module id = 1492
// module chunks = 0